import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(rateVideoRequest),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doUpdateVideoFilter),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doUpdateVideoList),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadOnDemandVideos),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadVideoCollection),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadVideos),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadVideoStacks),
    _marked8 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadUpcomingVideos),
    _marked9 =
/*#__PURE__*/
regeneratorRuntime.mark(doRateVideo),
    _marked10 =
/*#__PURE__*/
regeneratorRuntime.mark(watchVideos),
    _marked11 =
/*#__PURE__*/
regeneratorRuntime.mark(watchOnDemandVideos),
    _marked12 =
/*#__PURE__*/
regeneratorRuntime.mark(watchVideoCollection),
    _marked13 =
/*#__PURE__*/
regeneratorRuntime.mark(watchLoadUpcomingVideos),
    _marked14 =
/*#__PURE__*/
regeneratorRuntime.mark(watchLoadVideos),
    _marked15 =
/*#__PURE__*/
regeneratorRuntime.mark(watchUpdateVideoList);

import cookie from 'cookie';
import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { errorActionCreator } from 'redux/saga/helpers';
import { push as updatePath } from 'react-router-redux';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { liveVideos, onDemandVideos, videoCollection, userPermissions, userProfile, videos, videosFilters, videoStacks, videoViewRatings } from 'redux/saga/entities/bound';
import { filterSetFilters, pathSelector } from 'redux/saga/selectors';
import { resetRating } from 'redux/modules/rating';
import { showModal, hideModal } from 'redux/modules/modals';
import { RATINGS_MODAL_MAX_SHOW } from 'constants/video';
import { actionsForFilterSet } from 'redux/modules/filtersets';
import { createQuerystringFromFilters, writeFiltersFromQuerystring } from 'redux/saga/helpers/filters';
import { ec } from 'helpers/multitrack';
export var LOAD_VIDEO_STACKS = 'LOAD_VIDEO_STACKS';
export var LOAD_UPCOMING_VIDEOS = 'LOAD_UPCOMING_VIDEOS';
export var LOAD_VIDEOS = 'LOAD_VIDEOS';
export var RATE_VIDEO = 'RATE_VIDEO';
export var LOAD_ONDEMAND_VIDEOS = 'LOAD_ONDEMAND_VIDEOS';
export var LOAD_VIDEO_COLLECTION = 'LOAD_VIDEO_COLLECTION';
export var LOAD_VIDEO_ERROR = 'LOAD_VIDEO_ERROR';
export var UPDATE_VIDEO_FILTER = 'UPDATE_VIDEO_FILTER';
export var UPDATE_VIDEO_LIST = 'UPDATE_VIDEO_LIST';
export var FILTERSET_NAME = 'videos';
export var filterActions = actionsForFilterSet(FILTERSET_NAME);
export var loadVideos = function loadVideos(params, options) {
  return {
    type: LOAD_VIDEOS,
    params: params,
    options: options
  };
};
export var loadOnDemandVideos = function loadOnDemandVideos() {
  return {
    type: LOAD_ONDEMAND_VIDEOS
  };
};
export var loadVideoCollection = function loadVideoCollection(collectionId) {
  return {
    type: LOAD_VIDEO_COLLECTION,
    collectionId: collectionId
  };
};
export var loadVideoStacks = function loadVideoStacks() {
  return {
    type: LOAD_VIDEO_STACKS
  };
};
export var loadUpcomingVideos = function loadUpcomingVideos() {
  return {
    type: LOAD_UPCOMING_VIDEOS
  };
};
export var rateVideo = function rateVideo(userId, payload) {
  return {
    type: RATE_VIDEO,
    userId: userId,
    payload: payload
  };
};
export var updateVideoFilter = function updateVideoFilter(filter, option) {
  return {
    type: UPDATE_VIDEO_FILTER,
    filter: filter,
    option: option
  };
};
export var updateVideoList = function updateVideoList() {
  return {
    type: UPDATE_VIDEO_LIST
  };
};
export var loadVideoError = errorActionCreator.bind(null, LOAD_VIDEO_ERROR);
export function rateVideoRequest(client, userId, payload) {
  return regeneratorRuntime.wrap(function rateVideoRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return client.videos.createVideoViewRating(userId, payload);

        case 2:
          return _context.abrupt("return", _context.sent);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function onModalClose() {
  return false;
}
export function doUpdateVideoFilter(client, _ref) {
  var filter, option, _ref2, _ref3, query, pathname;

  return regeneratorRuntime.wrap(function doUpdateVideoFilter$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          filter = _ref.filter, option = _ref.option;
          _context2.prev = 1;

          if (!option) {
            _context2.next = 7;
            break;
          }

          _context2.next = 5;
          return put(filterActions.toggleItemId(filter, [option]));

        case 5:
          _context2.next = 14;
          break;

        case 7:
          if (!filter) {
            _context2.next = 12;
            break;
          }

          _context2.next = 10;
          return put(filterActions.clearFilter(filter));

        case 10:
          _context2.next = 14;
          break;

        case 12:
          _context2.next = 14;
          return put(filterActions.clearFilterSet());

        case 14:
          _context2.next = 16;
          return all([select(createQuerystringFromFilters, FILTERSET_NAME), select(pathSelector)]);

        case 16:
          _ref2 = _context2.sent;
          _ref3 = _slicedToArray(_ref2, 2);
          query = _ref3[0];
          pathname = _ref3[1];
          _context2.next = 22;
          return put(updatePath({
            pathname: pathname,
            query: query
          }));

        case 22:
          _context2.next = 28;
          break;

        case 24:
          _context2.prev = 24;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 28;
          return put(loadVideoError(_context2.t0));

        case 28:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 24]]);
}
export function doUpdateVideoList(client) {
  var user, _ref4, _ref5, permissions, reduxFilters, filters, filterOptions, res;

  return regeneratorRuntime.wrap(function doUpdateVideoList$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 3:
          user = _context3.sent;
          _context3.next = 6;
          return all([call(fetchEntityIfNeeded, userPermissions, [client, user.id]), call(writeFiltersFromQuerystring, filterActions, FILTERSET_NAME)]);

        case 6:
          _ref4 = _context3.sent;
          _ref5 = _slicedToArray(_ref4, 1);
          permissions = _ref5[0];
          _context3.next = 11;
          return select(filterSetFilters, FILTERSET_NAME);

        case 11:
          reduxFilters = _context3.sent;
          filters = Object.keys(reduxFilters).reduce(function (acc, filter) {
            if (reduxFilters[filter].countSelected > 0) {
              acc[filter] = Object.keys(reduxFilters[filter].itemIdSelected);
            }

            return acc;
          }, {});
          filterOptions = _objectSpread({}, filters, {
            cp_home_beta: permissions.feature_videos_live_tests || false
          });
          _context3.next = 16;
          return call(fetchEntity, videos, [client, filterOptions]);

        case 16:
          res = _context3.sent;
          _context3.next = 19;
          return call(ec, 'Video Search', {
            filters_applied: Object.keys(filters).filter(function (k) {
              return reduxFilters[k].countSelected > 0;
            }),
            activity: filters.activities,
            duration_bucket: filters.durations,
            studio_selected: filters.partners,
            number_results: res.length
          });

        case 19:
          _context3.next = 25;
          break;

        case 21:
          _context3.prev = 21;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 25;
          return put(loadVideoError(_context3.t0));

        case 25:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 21]]);
}
export function doLoadOnDemandVideos(client) {
  return regeneratorRuntime.wrap(function doLoadOnDemandVideos$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return call(fetchEntityIfNeeded, onDemandVideos, [client]);

        case 3:
          _context4.next = 9;
          break;

        case 5:
          _context4.prev = 5;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 9;
          return put(loadVideoError(_context4.t0));

        case 9:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 5]]);
}
export function doLoadVideoCollection(client, _ref6) {
  var collectionId;
  return regeneratorRuntime.wrap(function doLoadVideoCollection$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          collectionId = _ref6.collectionId;
          _context5.prev = 1;
          _context5.next = 4;
          return call(fetchEntityIfNeeded, videoCollection, [client, 'curated', collectionId]);

        case 4:
          _context5.next = 10;
          break;

        case 6:
          _context5.prev = 6;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 10;
          return put(loadVideoError(_context5.t0));

        case 10:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 6]]);
}
export function doLoadVideos(client) {
  var filters, populateFilters;
  return regeneratorRuntime.wrap(function doLoadVideos$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return call(fetchEntityIfNeeded, videosFilters, [client, {
            app: 'web'
          }]);

        case 3:
          filters = _context6.sent;
          // populate filters
          populateFilters = filters.map(function (filter) {
            return put(filterActions.addFilter(filter.ref, filter.options.map(function (option) {
              return {
                id: option.ref
              };
            })));
          });
          _context6.next = 7;
          return all([].concat(_toConsumableArray(populateFilters), [call(doUpdateVideoList, client)]));

        case 7:
          _context6.next = 13;
          break;

        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 13;
          return put(loadVideoError(_context6.t0));

        case 13:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[0, 9]]);
}
export function doLoadVideoStacks(client) {
  var user, permissions, options, clientTimeZone, pending, ratingCookie, exceedsLimit;
  return regeneratorRuntime.wrap(function doLoadVideoStacks$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 3:
          user = _context7.sent;
          _context7.next = 6;
          return call(fetchEntityIfNeeded, userPermissions, [client, user.id]);

        case 6:
          permissions = _context7.sent;
          options = {
            platform: 'web'
          };
          clientTimeZone = global.Intl.DateTimeFormat().resolvedOptions().timeZone;

          if (permissions.feature_videos_live_tests) {
            options.cp_home_beta = 1;
            options.top_users = 1;
          } // TODO: handle unpermissioned flow


          if (clientTimeZone) {
            options.timezone_name = clientTimeZone;
          }

          _context7.next = 13;
          return call(fetchEntityIfNeeded, videoStacks, [client, options]);

        case 13:
          _context7.next = 15;
          return call(fetchEntity, videoViewRatings, [client, user.id]);

        case 15:
          pending = _context7.sent;
          // Modal can only display a maximum of 5 times per browser session
          ratingCookie = cookie.parse(document.cookie).rating_modal_count || 0;
          exceedsLimit = ratingCookie && parseInt(ratingCookie, 10) >= RATINGS_MODAL_MAX_SHOW;

          if (!(pending.length > 0 && !exceedsLimit)) {
            _context7.next = 21;
            break;
          }

          _context7.next = 21;
          return put(showModal('VideosRatingsModal', {
            userId: user.id,
            onModalClose: onModalClose
          }));

        case 21:
          _context7.next = 27;
          break;

        case 23:
          _context7.prev = 23;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 27;
          return put(loadVideoError(_context7.t0));

        case 27:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[0, 23]]);
}
export function doLoadUpcomingVideos(client) {
  return regeneratorRuntime.wrap(function doLoadUpcomingVideos$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return call(fetchEntityIfNeeded, liveVideos, [client, {
            upcoming: 1
          }]);

        case 3:
          _context8.next = 9;
          break;

        case 5:
          _context8.prev = 5;
          _context8.t0 = _context8["catch"](0);
          _context8.next = 9;
          return put(loadVideoError(_context8.t0));

        case 9:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[0, 5]]);
}
export function doRateVideo(client, _ref7) {
  var userId, payload, pending, ratingCookie;
  return regeneratorRuntime.wrap(function doRateVideo$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          userId = _ref7.userId, payload = _ref7.payload;
          _context9.prev = 1;
          _context9.next = 4;
          return call(rateVideoRequest, client, userId, payload);

        case 4:
          _context9.next = 6;
          return call(fetchEntity, videoViewRatings, [client, userId]);

        case 6:
          pending = _context9.sent;

          if (!(pending.length === 0)) {
            _context9.next = 10;
            break;
          }

          _context9.next = 10;
          return put(hideModal('VideosRatingsModal'));

        case 10:
          _context9.next = 12;
          return put(resetRating());

        case 12:
          _context9.next = 23;
          break;

        case 14:
          _context9.prev = 14;
          _context9.t0 = _context9["catch"](1);
          ratingCookie = cookie.parse(document.cookie).rating_modal_count || 0;

          if (!(parseInt(ratingCookie, 10) >= RATINGS_MODAL_MAX_SHOW)) {
            _context9.next = 22;
            break;
          }

          _context9.next = 20;
          return put(hideModal('VideosRatingsModal'));

        case 20:
          _context9.next = 23;
          break;

        case 22:
          document.cookie = "rating_modal_count=".concat(parseInt(ratingCookie, 10) + 1);

        case 23:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9, null, [[1, 14]]);
}
export function watchVideos(client) {
  return regeneratorRuntime.wrap(function watchVideos$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return fork(takeEvery, LOAD_VIDEO_STACKS, doLoadVideoStacks, client);

        case 2:
          _context10.next = 4;
          return fork(takeEvery, RATE_VIDEO, doRateVideo, client);

        case 4:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}
export function watchOnDemandVideos(client) {
  return regeneratorRuntime.wrap(function watchOnDemandVideos$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return fork(takeEvery, LOAD_ONDEMAND_VIDEOS, doLoadOnDemandVideos, client);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}
export function watchVideoCollection(client) {
  return regeneratorRuntime.wrap(function watchVideoCollection$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return fork(takeEvery, LOAD_VIDEO_COLLECTION, doLoadVideoCollection, client);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}
export function watchLoadUpcomingVideos(client) {
  return regeneratorRuntime.wrap(function watchLoadUpcomingVideos$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return fork(takeEvery, LOAD_UPCOMING_VIDEOS, doLoadUpcomingVideos, client);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}
export function watchLoadVideos(client) {
  return regeneratorRuntime.wrap(function watchLoadVideos$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return fork(takeEvery, LOAD_VIDEOS, doLoadVideos, client);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}
export function watchUpdateVideoList(client) {
  return regeneratorRuntime.wrap(function watchUpdateVideoList$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return fork(takeEvery, UPDATE_VIDEO_LIST, doUpdateVideoList, client);

        case 2:
          _context15.next = 4;
          return fork(takeEvery, UPDATE_VIDEO_FILTER, doUpdateVideoFilter, client);

        case 4:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}